class ComparisonTable extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      columns: '.new-comparison-table__column:not(.new-comparison-table__column--main)',
      activeColumn: 'new-comparison-table__column--active',
      buttons: '.new-comparison-table__tab-button',
      activeButton: 'new-comparison-table__tab-button--active'
    };
  }

  connectedCallback() {
    this.columns = this.querySelectorAll(this.selectors.columns);
    this.buttons = this.querySelectorAll(this.selectors.buttons);
    this.buttons.forEach(button => {
      button.addEventListener('click', (event) => this.activeTabChange(event));
    });
  }

  activeTabChange(event) {
    const currentButton = event.currentTarget;
    const tabId = +currentButton.dataset.id;

    this.buttons.forEach(button => {
      button.classList.remove(this.selectors.activeButton);
    });

    currentButton.classList.add(this.selectors.activeButton);

    this.columns.forEach(column => {
      if (column.dataset.id == tabId) {
        column.classList.add(this.selectors.activeColumn);
      } else {
        column.classList.remove(this.selectors.activeColumn);
      }
    });
  }
}

customElements.define('comparison-table', ComparisonTable);
